export const makeNumberArray = (number:number)=>{
    const res = []
    for (let i = 0;i<number;i++){
        res.push(i)
    }
    return res
}